import { SENNTEAMS_URL } from '@/common/config'
import { getAuthHeader } from '@/services/authService'

export enum TeamType {
  CHARTERING = 'CHARTERING',
}

export interface UserTeam {
  id: string
  name: string
  email: string
  team_id?: string | null
  team_name?: string | null
  team_type?: TeamType | string | null
  is_lead?: boolean | null
}

interface UserSearchQuery {
  query: string
}

/**
 * Finds the first chartering team in the provided list of teams.
 * Mirroring the logic from the Internal Auth micro-frontend.
 *
 * @param teams - An array of UserTeam objects to search through.
 * @returns The first UserTeam object that matches the chartering team criteria, or undefined if no match is found.
 */
export const findCharteringTeam = (teams: UserTeam[]): UserTeam | undefined => {
  return teams.find(
    (team) => team.team_type === TeamType.CHARTERING && team.team_name
  )
}

class SennteamsService {
  async getUserTeams(email: string): Promise<UserTeam[]> {
    const authHeader = await getAuthHeader()

    if (!authHeader) {
      throw new Error('[tms-shell - SennteamsService]: Auth header is empty')
    }

    const body: UserSearchQuery = { query: email }

    const response = await fetch(
      `${SENNTEAMS_URL}/api/search/user?include_team_lead=true`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeader,
        },
        body: JSON.stringify(body),
      }
    )

    if (!response.ok) {
      throw response
    }

    return response.json()
  }
}

export const sennteamsService = new SennteamsService()
